module.exports = __webpack_public_path__ + "images/stickers/rocketship.b44a048b811f0a404607.png";